import type { Channel } from '@/modules/connect/use-cases'

export type ChannelLastMessageDto = {
  messageId: string
  body?: string | null
  authorId?: string | null
  authorName?: string | null
  createdAt: string
}

export type ChannelDto = {
  id: string
  orgId: string
  orgType: 'club' | 'outfitter'
  name: string
  isDefault: boolean
  membershipMode?: 'open' | 'restricted' | null
  color?: string | null
  createdBy?: string | null
  archivedAt?: string | null
  createdAt: string
  updatedAt: string
  unreadCount?: number | null
  mutedAt?: string | null
  isMuted?: boolean | null
  lastMessage?: ChannelLastMessageDto | null
}

export function toChannel(dto: ChannelDto): Channel {
  return {
    id: dto.id,
    orgId: dto.orgId,
    orgType: dto.orgType,
    name: dto.name,
    isDefault: dto.isDefault,
    membershipMode: dto.membershipMode ?? 'open',
    color: dto.color ?? undefined,
    createdBy: dto.createdBy ?? undefined,
    archivedAt: dto.archivedAt ?? undefined,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    unreadCount: dto.unreadCount ?? 0,
    mutedAt: dto.mutedAt ?? undefined,
    isMuted: dto.isMuted ?? false,
    lastMessage: dto.lastMessage
      ? {
          messageId: dto.lastMessage.messageId,
          body: dto.lastMessage.body ?? '',
          authorId: dto.lastMessage.authorId ?? undefined,
          authorName: dto.lastMessage.authorName ?? undefined,
          createdAt: dto.lastMessage.createdAt,
        }
      : undefined,
  }
}
